import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthData } from '../store/redux/slices/Auth-slice';
import { selectPermissions } from '../store/redux/slices/Permission-slice';
import { isAppAdmin as checkAppAdmin } from '../permissions/app-admin';
import { FEATURES, ACTIONS } from '../permissions/constants';

const HotelGuard = ({ children }) => {
    const authData = useSelector(selectAuthData);
    const permissions = useSelector(selectPermissions);

    const hasHotel = authData?.hotel && Object.keys(authData.hotel).length > 0;
    const roleCode = authData?.user?.role_code;

    if (!hasHotel) {
        if (checkAppAdmin(roleCode)) {
            return <Navigate to="/tutorial-management" replace />;
        }
        if (permissions?.[FEATURES.ADMIN_DASHBOARD]?.includes(ACTIONS.VIEW)) {
            return <Navigate to="/admin" replace />;
        }
        if (!permissions) {
            return null;
        }
        return <Navigate to="/access-denied" replace />;
    }

    return <>{children}</>;
};

export default HotelGuard;
